export default __webpack_public_path__ + "static/media/Ring of Grounding.caf73d4f.jpg";